// extracted by mini-css-extract-plugin
export default {"error":"CreateResident_error__LagK4","successMessage":"CreateResident_successMessage__PODGF"};